import React from 'react';

import { animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { usePressSpring } from '~/styles/pressAnimation';

const ButtonBase = styled(animated.button)`
  position: relative;
  border: 0;
  border-radius: 64px;
  width: 56px;
  height: 56px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;
`;

const PressRing = styled.span`
  position: absolute;
  inset: 0;
  z-index: 0;
  border-radius: 64px;
  background: ${({ theme }) => theme.colors.pressableIconButtonRingBackground};
  filter: drop-shadow(
    0 1px 6px ${({ theme }) => theme.colors.pressableIconButtonRingDropShadow}
  );
  backdrop-filter: blur(5px);
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  transition: opacity ${({ $active }) => ($active ? 150 : 200)}ms ease;
  pointer-events: none;
`;

const IconWrapper = styled.span`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PressableIconButton = ({ children, onClick, className, ...rest }) => {
  const { isPressed, pressHandlers, springStyle } = usePressSpring();

  return (
    <ButtonBase
      type="button"
      className={className}
      onClick={onClick}
      style={springStyle}
      {...pressHandlers}
      {...rest}
    >
      <PressRing $active={isPressed} />
      <IconWrapper>{children}</IconWrapper>
    </ButtonBase>
  );
};

PressableIconButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default PressableIconButton;
